import { render } from "./MesRendezVous.vue?vue&type=template&id=8b7c0060"
import script from "./MesRendezVous.vue?vue&type=script&lang=js"
export * from "./MesRendezVous.vue?vue&type=script&lang=js"
script.render = render

export default script